<template>
    <div :ref="setRef" style="position: absolute; width: 500px; height: 300px;"></div>
</template>

<script>
import * as echarts from 'echarts'
// import 'echarts/theme/tw_dark.js'
import twDark from '../../../public/tw_dark'
import { onMounted, reactive } from "vue";

export default {
    name: 'tw-ws-dashboard',
    setup(props) {
        let myRef;

        const setRef = el => {
            myRef = el;
        }

        // 接口数据：http://api.jeecg.com/mock/26/bar
        let mockJson = reactive({"data":{
            "series":[{
                "name":"业务指标",
                "data":[{"value": 50, "name": '完成率'}],
                "detail": {"formatter": '{value}%', "color": '#fff'}
            }]}});

        if(mockJson && mockJson.data && mockJson.data.series){
            mockJson.data.series.forEach(function(val){
                val.title = {
                    show: true,
                    color: '#fff'
                }
                val.type = 'gauge';
                val.axisLine = {
                    show: true,
                    lineStyle: {
                    color: [
                        [1,new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                            {
                                offset: 0.1,
                                color: "#FFC600"
                            },
                            {
                                offset: 0.6,
                                color: "#30D27C"
                            },
                            {
                                offset: 1,
                                color: "#0B95FF"
                            }
                            ])
                        ]
                    ]
                    }
                };
                val.radius = "100%";
                // val.startAngle = 215;
                // val.endAngle = -35;
                val.splitCount = 60;
                val.center = ['50%', '60%'];
                val.splitLine = {
                    length: 15,
                    lineStyle: {
                        color: '#fff'
                    }
                };
                val.axisTick = {
                    lineStyle: {
                        color: '#fff'
                    }
                }
                val.axisLabel = {
                    color: '#fff'
                }
            })
        }

        const echartInit = () =>{
            echarts.registerTheme('tw_dark', twDark)
            var myChart = echarts.init(myRef, 'tw_dark');
            // 指定图表的配置项和数据
            var option = {
                title: {
                    text: props.title
                },
                legend: {
                    show: props.legendShow
                },
                tooltip: {
                    show: true,
                    trigger: 'item',
                    // backgroundColor: 'rgba(50,50,50,0.7)',
                    // textStyle: {
                    //     color: '#fff',
                    //     fontWeight: 'bolder',
                    //     fontSize: 18
                    // }
                },
                series: mockJson.data.series
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        }

        onMounted(()=>{
            echartInit()
        })

        return {
            setRef,
            echartInit
        };
    },
    
    props: {
        title: String,
        legendShow: {
            type: Boolean,
            default: true
        },
        url: String
    }
}
</script>

<style>

</style>
